import type { FaireProductEntity } from "../../entity_types/product";

export const p_fbd7qvgcgh: FaireProductEntity = {
  token: "p_fbd7qvgcgh",
  type: "product",
  name: "Neu Cereal Bowl s/2",
  brandToken: "b_dtfc7uc37e",
  brandName: "Aaron Probyn US",
  imageUrl:
    "https://cdn.faire.com/fastly/1775f5f516e48af987c45f36e8021e2531ae804e085ccb4109110ae156a2acb6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a553fb78bf8f4a2b1570a456cf5597fe96f9523f67570ca7393d2230e33b740d.jpeg",
    "https://cdn.faire.com/fastly/e2124353a0fd04b50074e1ded6983bfbc128ce8cb96004985068da3fa4994909.jpeg",
    "https://cdn.faire.com/fastly/a090ab78c9c4ec31c3b16ae7f5c825cc9e7c48595c5f23ae176769a23770972d.jpeg",
    "https://cdn.faire.com/fastly/7a82ee00dba4d7ff70ff2053c0c5a45fdccadb3d49d6d4f6d740ebf60f614d5b.jpeg",
    "https://cdn.faire.com/fastly/d59a8714f51b1a1af8ae45718f7baa64c4636b01544c9b37990de71381dcd508.jpeg",
    "https://cdn.faire.com/fastly/cc8026a39f7fb22e470056487fd2fd4aea048763f0dfb6ac9947858a8f2d49b9.jpeg",
    "https://cdn.faire.com/fastly/a55511659d5e06b5ea644294dce352d55acefa3b6e06fdfc79303248f4f1641d.png",
    "https://cdn.faire.com/fastly/290b5edb5b1af9326b8caf8bdc33d4016c18e8503a9c711e857f2975eebc1568.png",
    "https://cdn.faire.com/fastly/7e698c3b2b2f51f7b44bfceb65486fa613b3d948d9f7d214a7e72dde36228679.png",
    "https://cdn.faire.com/fastly/8abd7f9fbe522f7fc565ea76081e031de6a7f54d61104e2c3a50decb543ced74.png",
    "https://cdn.faire.com/fastly/2af1330a07312aed5b344c05cd8bdca1d343d16828946e54891dcd81f8767731.png",
    "https://cdn.faire.com/fastly/1e09d00302744cbb3e9ae163677fde84d13e5b241ffc25d96fda9280bcf28a83.png",
  ],
  priceDollars: 15,
  description:
    "NEU, meaning “new” in German, is a pleasing dinnerware range that pays homage to the Bauhaus ideals where form and detailing is dictated by the function and production of an object. Each piece of Neu is stackable; the punctuated details are designed to maximise storage space.\n\nMaterial: Stoneware\n\nDishwasher and microwave-safe.\n\nSize: Ø13 x 7.5 cm\nSet of 2",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-04T23:53:32.243Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
